import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ITutorialState } from '@medlogic/medlogic/medlogic-shared-interfaces';
import * as fromTutorial from './tutorial.reducer';

export const selectTutorialState = createFeatureSelector<ITutorialState>(fromTutorial.tutorialFeatureKey);

export const selectTutorials = createSelector(selectTutorialState, fromTutorial.selectAll);

